<div *ngIf="artists | async; let artists">
 	<span *ngFor="let artist of artists">
		{{ artist.lastname }}
	</span>
</div>